const defaultRoutes = {
  postLogin: '/customers'
};

export { defaultRoutes };
